import { Button } from '@/components/ui/button';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { MONTH_NAMES } from './dreUtils';
import type { DREPeriodFilter } from './types';

interface Props {
  filter: DREPeriodFilter;
  onChange: (filter: DREPeriodFilter) => void;
}

export function DREFilters({ filter, onChange }: Props) {
  const currentYear = new Date().getFullYear();

  const handleFromChange = (value: string) => {
    const fromMonth = Number(value);
    onChange({
      ...filter,
      fromMonth,
      toMonth: filter.toMonth < fromMonth ? fromMonth : filter.toMonth,
    });
  };

  const handleToChange = (value: string) => {
    const toMonth = Number(value);
    onChange({ ...filter, toMonth });
  };

  return (
    <div className="flex flex-wrap items-end gap-3">
      <div className="space-y-1.5">
        <span className="text-xs font-medium text-muted-foreground">Ano</span>
        <div className="flex items-center gap-1">
          <Button
            variant="outline"
            size="icon"
            className="h-9 w-9"
            onClick={() => onChange({ ...filter, year: filter.year - 1 })}
            disabled={filter.year <= currentYear - 5}
          >
            <ChevronLeft className="h-4 w-4" />
          </Button>
          <div className="flex h-9 min-w-[80px] items-center justify-center rounded-md border border-input bg-background px-3 font-semibold">
            {filter.year}
          </div>
          <Button
            variant="outline"
            size="icon"
            className="h-9 w-9"
            onClick={() => onChange({ ...filter, year: filter.year + 1 })}
            disabled={filter.year >= currentYear + 2}
          >
            <ChevronRight className="h-4 w-4" />
          </Button>
        </div>
      </div>

      <div className="space-y-1.5">
        <span className="text-xs font-medium text-muted-foreground">De</span>
        <Select value={String(filter.fromMonth)} onValueChange={handleFromChange}>
          <SelectTrigger className="w-[150px]">
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            {MONTH_NAMES.map((name, i) => (
              <SelectItem key={name} value={String(i + 1)}>
                {name}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>

      <div className="space-y-1.5">
        <span className="text-xs font-medium text-muted-foreground">Até</span>
        <Select value={String(filter.toMonth)} onValueChange={handleToChange}>
          <SelectTrigger className="w-[150px]">
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            {MONTH_NAMES.map((name, i) => {
              const month = i + 1;
              return (
                <SelectItem key={name} value={String(month)} disabled={month < filter.fromMonth}>
                  {name}
                </SelectItem>
              );
            })}
          </SelectContent>
        </Select>
      </div>
    </div>
  );
}
